import React from 'react'
import { SliderContainer } from '../style'
import { useFormContext, useWatch } from 'react-hook-form'
import { MaxValueLabel, MinValueLabel, SliderC, SliderWrapper } from '~/pages/Farmer/Survey/RequestEntries/AnswerForms/Slider'

interface Props {
  secondaryHarvestKey: string
  primaryHarvestKey: string
}

const HarvestSlider: React.FC<Props> = ({ primaryHarvestKey, secondaryHarvestKey }) => {
  const { control, setValue } = useFormContext()

  const watchSecondaryHarvestPercent = useWatch({ control, name: secondaryHarvestKey })

  return <SliderContainer>
    <SliderWrapper>
      <MinValueLabel style={{ fontWeight: 'normal' }}>{'0%'}</MinValueLabel>
      <SliderC
        step={1}
        rating={watchSecondaryHarvestPercent / 49 * 100}
        min={0}
        max={49}
        value={watchSecondaryHarvestPercent}
        onChange={(e) => {
          setValue(secondaryHarvestKey, e.target.value)
          setValue(primaryHarvestKey, 100 - parseInt(e.target.value))
        }}
      />
      <MaxValueLabel style={{ fontWeight: 'normal' }}>{'49%'}</MaxValueLabel>
    </SliderWrapper>
  </SliderContainer>
}
export default HarvestSlider